import React from 'react'
import { useEffect } from 'react';
import { Helmet } from 'react-helmet'

import Seo from '../uglib_components/seo'
import Layout from '../uglib_components/layout';
import ContactForm from '../uglib_components/contactForm';
import AskChat from '../uglib_components/askChat';

const title = "We're sorry, we can't find the page that you're looking for."

const header = <>
    <Helmet><script defer type="text/javascript" src="/assets/uog-media-player.js"></script></Helmet>
    <Seo title={title} keywords={[]} />

    { /**** Header and Title ****/ }
    <div className="no-thumb" id="rotator">				
        <div className="container ft-container">
            <h1 className="fancy-title">{title}</h1>
        </div>
    </div>
</>;



const NotFoundPage = ({location}) => {
    const search_url = `https://www.uoguelph.ca/search`;

    useEffect(() => {
        const sanitize = function(str) {
            str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim," ");
            str = str.replace('-', ' ');
            return str.trim();
        }
        
        const pathname = window.location.pathname;
        const search_query = sanitize(pathname);
        const search_link = document.getElementById('search-link');
        const search_orig_href = search_link.attributes['href'].value;
        
        search_link.setAttribute('href', `${search_orig_href}?q=${search_query}`);
    })

    return (
        <Layout title={title} header={header} keywords={['library', 'research', 'guelph']} bodyClass='not-found'>
            <div className="container page-container container-fluid">
                <p className="error">Try <a id="search-link" href={search_url}>searching</a> for your page. Need help? Contact us on the phone, through email, or through online chat below.</p>
                <div className="row">
                    <div className="col-md-6">
                        <h2>Speak With Us</h2>
                        <ul>
                            <li>Main Phone: (519) 824 - 4120 x53617</li>
                            <li>Ask Us Desk: (519) 824 - 4120 x53618</li>
                            <li>IT Help: (519) 824 - 4120 x58888</li>
                            <li>Archival &amp; Special Collections: (519) 824 - 4120 x53413</li>
                            <li>TUG Annex: (519) 821-7946</li>
                            <li><a href="/about/staff-directory" id="staff-directory">Staff Directory</a></li>
                            <li>In person at the <a href="/where/areas/area/circinfo">Ask Us Desk</a></li>
                        </ul>
                        <h2>Chat With Us</h2>
                        <AskChat />
                        <h2>More Information</h2>
                        <p>Check out the <a href="/using-library/frequently-asked-questions-faq">Library FAQs</a></p>
                    </div>
                    <div className="col-md-6">
                            <h2>Email Us</h2>
                            <p>Have a question, comment, or suggestion? Please email us using the form below or email <a href="mailto:library@uoguelph.ca">library@uoguelph.ca</a>. We promise a real person will respond to you ASAP. We normally answer questions within one business day.</p>
                            <ContactForm />	
                    </div>	
                </div>
                        
                </div>

        </Layout>
    );
}

export default NotFoundPage
